<template>
<div class="recommends">
    <phone-recommend-list-item  v-for="(item,index) in recommends" :recommend-item="item" :key="index"/>
</div>
</template>

<script>
import PhoneRecommendListItem from '../content/PhoneRecommendListItem.vue'

export default {
    name:'PhoneRecommendList',
    components:{
        PhoneRecommendListItem
    },
    props:{
        recommends:{
            type:Array,
            default(){
                return []
            }
        }
    }
}
</script>

<style scoped>
    .recommends{
        column-count: 2;
        align-self: start;
    }



</style>


// WEBPACK FOOTER //
// src/components/content/PhoneRecommendList.vue